import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {ConfirmComponent} from "../../../../../../common/components/confirm/confirm.component";
import {Api, ApiService} from "../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../common/services/toast.service";
import {UserService} from "../../../../../../common/services/user.service";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {SpinnerService} from "../../../../../../common/services/spinner.service";
import {Table} from "src/modules/common/interfaces/table.interface";
import {Table2Component} from "src/modules/common/components/table2";

@Component({
    selector: "section-partner-list",
    templateUrl: "list.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PartnerListComponent implements Base.IComponent, OnInit {

    @ViewChild(ConfirmComponent, {static: false})
    public confirmRef: ConfirmComponent;

    @ViewChild(Table2Component, {static: false})
    public tableRef: Table2Component;

    public listTable: Table.ISettings;

    public readonly state: Base.IState;

    public constructor(
        private router: Router,
        private apiService: ApiService,
        private toastService: ToastService,
        private userService: UserService,
        private spinnerService: SpinnerService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    /**
     * Prepare list/table
     * @returns {void}
     */
    private prepareList(): void {
        const actions: Table.IAction[] = [];
        if (this.userService.validatePermissions("edit_partners")) {
            actions.push({
                name: "edit",
                title: "Edit",
                click: (row) => this.edit(row.id)
            });
        }
        if (this.userService.validatePermissions("delete_partners")) {
            actions.push({
                name: "delete",
                title: "Delete",
                click: (row) => this.delete(row)
            });
        }
        const columns: Table.ICol[] = [
            {
                data: "id",
                title: "ID",
                searchable: false
            },
            {
                data: "display_name",
                title: "Display name"
            },
            {
                data: "slug",
                title: "Code (slug)"
            },
            {
                data: "created_at",
                title: "Creation date",
                searchable: false
            }
        ];

        this.listTable = {
            table_id: "admin_partners",
            actions,
            api: {
                url: ["partner"]
            },
            columns
        };
        this.changeDetectorRef.markForCheck();
    }

    private edit(id: any): void {
        this.router.navigate([this.state.section, this.state.component, "edit", "id", id]);
    }

    private async delete(row: any): Promise<void> {
        if (await this.confirmRef.confirm(
            `All associated data will be deleted. Action cannot be reverted!`,
            `Delete partner ${row.display_name}?`
        )) {
            this.spinnerService.show();
            const {data, message}: Api.IResponse =
                await this.apiService.request(Api.EMethod.Delete, ["partner", row.id]);
            this.spinnerService.hide();
            if (data) {
                this.toastService.show(message, "success");
                this.tableRef.reload();
            }
        }
    }

    public ngOnInit(): void {
        this.prepareList();
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "partner",
            actions: {
                "browse": ["browse_partners"]
            }
        };
    }

}
